// extracted by mini-css-extract-plugin
module.exports = {"jcGrey800":"#202d38","jcGrey200":"#e3e8e9","emailBadge":"EmailBadge__emailBadge","email":"EmailBadge__email"};